import { emptyFragment } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { fromArrayMaybe } from 'nonempty-list';
import { currentUserStore } from '../../../../CurrentUserStore';
import { useQueryWithDecoder } from '../../../../UseQueryWithDecoder';
import EmptyLicenseInsights from '../../../EmptyComponents/EmptyLicenseInsights';
import CardTitle from '../../Shared/CardTitle';
import { licenseInsightsResourceDecoder } from './Decoder';
import LicenseInsightsSkeleton from './LicenseInsightsSkeleton';
import Overview from './Overview';

function LicenseInsights() {
  const { data, isLoading, error } = useQueryWithDecoder(
    'license-insights',
    currentUserStore.links,
    licenseInsightsResourceDecoder,
  );

  if (isLoading) {
    return <LicenseInsightsSkeleton />;
  }

  if (error || !data) {
    console.error('Failed to load license insights:', error);
    return emptyFragment();
  }

  return (
    <div className="w-full">
      <CardTitle title="License Insights" />
      {fromArrayMaybe(data.payload)
        .map((resource) => <Overview licenseInsights={resource} />)
        .getOrElse(() => (
          <EmptyLicenseInsights />
        ))}
    </div>
  );
}
export default observer(LicenseInsights);
